class IcarusCartValidator {
    constructor() {
        this.checkoutBtn = document.getElementById('checkout');
        this.cartForm = document.getElementById('cart-form');
        this.notificationContainer = null;
        this.isValidating = false;
        this.validationInterval = null;
        this.cache = new Map();

        this.createNotificationContainer();
        this.init();
    }

    createNotificationContainer() {
        this.notificationContainer = document.createElement('div');
        this.notificationContainer.id = 'icarus-cart-notifications';
        this.notificationContainer.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      z-index: 100000000;
      display: flex;
      flex-direction: column;
      gap: 10px;
      max-width: 400px;
    `;
        document.body.appendChild(this.notificationContainer);
    }

    init() {
        this.validateCart();

        if (this.checkoutBtn) {
            this.checkoutBtn.addEventListener('click', (e) => this.handleCheckout(e));
        }

        this.startPeriodicCheck();

        window.addEventListener('beforeunload', () => {
            if (this.validationInterval) clearInterval(this.validationInterval);
        });
    }

    async validateCart(cartData = null, forceRefresh = false) {
        if (this.isValidating) return true;
        this.isValidating = true;

        try {
            const cart = cartData || await fetch('/cart.js').then(r => r.json());
            let hasUnavailableItems = false;
            const removals = [];

            for (const item of cart.items) {
                const jerseyNumber = item.properties?.['Jersey Number'];
                if (jerseyNumber) {
                    const isAvailable = await this.checkItemAvailability(item.handle, item.variant_id, jerseyNumber, forceRefresh);
                    if (!isAvailable) {
                        hasUnavailableItems = true;
                        removals.push(this.removeItem(item, jerseyNumber));
                    }
                }
            }

            if (removals.length > 0) {
                await Promise.all(removals);
                window.location.reload();
                return false;
            }

            return true;
        } catch (error) {
            console.error('Icarus Cart Validation Error:', error);
            return true;
        } finally {
            this.isValidating = false;
        }
    }

    async checkItemAvailability(handle, variantId, position, forceRefresh = false) {
        try {
            let data;
            if (!forceRefresh && this.cache.has(handle)) {
                data = this.cache.get(handle);
            } else {
                const url = `/products/${handle}?view=match-json${forceRefresh ? `&v=${Date.now()}` : ''}`;
                const response = await fetch(url);
                data = await response.json();
                this.cache.set(handle, data);
            }

            const variant = data.variants.find(v => v.id === variantId);
            if (!variant) return true;

            const soldPositions = Array.isArray(variant.sold_positions) ? variant.sold_positions : [];
            const isSold = soldPositions.some(p => parseInt(p) === parseInt(position));

            return !isSold;
        } catch (e) {
            console.error(`Error checking availability for ${handle}:`, e);
            return true;
        }
    }

    async removeItem(item, num) {
        this.showNotification(`Position ${num} for ${item.product_title} is no longer available and has been removed.`, 'warning');
        return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                id: item.key,
                quantity: 0
            })
        });
    }

    async handleCheckout(e) {
        if (this.isValidating || !this.checkoutBtn) return;

        e.preventDefault();
        const originalText = this.checkoutBtn.textContent;
        this.checkoutBtn.setAttribute('disabled', 'true');

        try {
            // Get current cart state
            const cart = await fetch('/cart.js').then(r => r.json());

            // Check if we need to show the "Validating positions" message
            const hasMatchItems = cart.items.some(item => item.properties && item.properties['Jersey Number']);

            if (hasMatchItems) {
                this.checkoutBtn.textContent = 'Validating positions...';
            } else {
                this.checkoutBtn.textContent = 'Processing...';
            }

            const isAllValid = await this.validateCart(cart, true);

            if (!isAllValid) {
                // Reload is handled by validateCart
            } else {
                this.checkoutBtn.textContent = originalText;
                this.checkoutBtn.removeAttribute('disabled');
                if (this.cartForm && this.cartForm instanceof HTMLFormElement) {
                    // Ensure Shopify sees this as a checkout request
                    if (!this.cartForm.querySelector('input[name="checkout"]')) {
                        const checkoutInput = document.createElement('input');
                        checkoutInput.type = 'hidden';
                        checkoutInput.name = 'checkout';
                        checkoutInput.value = 'checkout';
                        this.cartForm.appendChild(checkoutInput);
                    }
                    this.cartForm.submit();
                } else {
                    window.location.href = '/checkout';
                }
            }
        } catch (error) {
            console.error('Checkout error:', error);
            this.checkoutBtn.textContent = originalText;
            this.checkoutBtn.removeAttribute('disabled');
        }
    }

    startPeriodicCheck() {
        this.validationInterval = setInterval(() => this.validateCart(), 30000);
    }

    showNotification(msg, type = 'info') {
        // Check for an open dialog (Top Layer) to stay on top of drawers
        const openDialog = document.querySelector('dialog[open]');
        const targetContainer = openDialog || document.body;

        // Find or create local container inside the target
        let container = targetContainer.querySelector('#icarus-cart-notifications');
        if (!container) {
            container = document.createElement('div');
            container.id = 'icarus-cart-notifications';
            container.style.cssText = `
                position: ${openDialog ? 'absolute' : 'fixed'};
                top: 20px;
                right: 20px;
                z-index: 100000000;
                display: flex;
                flex-direction: column;
                gap: 10px;
                max-width: 400px;
                pointer-events: none;
            `;
            targetContainer.appendChild(container);
        }

        const toast = document.createElement('div');
        toast.style.cssText = `
            background: ${type === 'warning' ? '#ff3333' : '#333'};
            color: white;
            padding: 15px 20px;
            border-radius: 8px;
            font-size: 14px;
            font-weight: 600;
            box-shadow: 0 4px 12px rgba(0,0,0,0.2);
            animation: slideIn 0.3s ease-out;
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 15px;
            pointer-events: auto;
        `;

        toast.innerHTML = `
            <span>${msg}</span>
            <button style="background:none; border:none; color:white; cursor:pointer; font-size:18px;">&times;</button>
        `;

        toast.querySelector('button').onclick = () => toast.remove();
        container.appendChild(toast);

        setTimeout(() => {
            if (toast.parentElement) toast.remove();
            // Clean up container if empty and inside a dialog
            if (container.children.length === 0 && openDialog && container.parentElement) {
                container.remove();
            }
        }, 5000);
    }
}

const style = document.createElement('style');
style.textContent = `
  @keyframes slideIn {
    from { transform: translateX(100%); opacity: 0; }
    to { transform: translateX(0); opacity: 1; }
  }
`;
document.head.appendChild(style);

document.addEventListener('DOMContentLoaded', () => {
    window.icarusCartValidator = new IcarusCartValidator();
});
